module.exports = __webpack_public_path__ + "img/range-yd.48de963c.png";